import { sendCriteoEvent } from '@ma-js-common/criteo-helpers';
import * as Highcharts from 'highcharts';
import $ from 'jquery';
import urlJoin from 'url-join';
import { v4 as uuidv4 } from 'uuid';

import { init as InitCommonAccordion, initInlineAccordion } from '../common/accordion';
import * as Common from '../common/common.es6';
import {
    ADDRESS_GEOTYPE_LABEL,
    ARRMUN_GEOTYPE_LABEL,
    BOROUGH_GEOTYPE_LABEL,
    CITY_GEOTYPE_LABEL,
    REGION_GEOTYPE_LABEL,
    STREET_GEOTYPE_LABEL,
    SUBCITY_GEOTYPE_LABEL,
    SUBREGION_GEOTYPE_LABEL,
} from '../common/constants.es6';
import { computeCriteoAType, getRealtorIds } from '../common/criteo-tagging';
import { hasTouchEvents, isMobile } from '../common/device';
import * as domHelpers from '../common/domHelpers';
import { initializeFeaturedRealtors, loadFeaturedRealtors } from '../common/featured-realtors';
import Ga from '../common/ga';
import MAEvent from '../common/ma-event';
import Navigation from '../common/navigation';
import { initializePastSalePopin, initializeRealtorMessagePopin } from '../common/popin.es6';
import * as RealtorMap from '../common/realtor-map.es6';
import { typeaheadPlaceFieldDatasets } from '../common/search';
import HTTPService from '../common/services/HTTPService.es6';
import spinnerTemplate from '../common/templates/spinner-dots.html';
import {
    EstateType,
    getThorViewEventProps,
    thorFormatPlaceName,
    thorPushEvent,
} from '../common/thor';
import Wa from '../common/wa';
import { init as TooltipInit } from '../tooltip';
import { MapHelpers } from '../vectormap/helpers.es6';
import MapboxMap from '../vectormap/map.es6';

require('jquery-unveil');
require('qtip2');
require('magnific-popup');

let currentPlace = null;
let currentPlacePrices = null;
let mapIsLoaded = false;
let userDisableEstimaPopover = false;
let toggleView;
let pendingAvivFeatureId = null; // AVIV feature ID from map click, stored in history state
let pendingIsMapClick = false; // Flag indicating navigation originated from map click

/**
 * Price pages GA category
 * @type {String}
 */
const GA_CATEGORY = 'Page prix';

/**
 * Selector for realtor Item in the list
 * @type {string}
 */
const realtorItemSelector = '[data-realtor-contact-item]';

const $pricesDetailsContent = $('[data-prices-details-content]');
const $mapContainer = $('[data-prices-map]');
const $pricesDetails = $('[data-prices-details]');

const LOADING_WRAPPER_ACTIVE = 'loading-wrapper--loading';
const TOGGLE_VIEW_ACTIVE = 'active';
const HOVER_ACTIVE = 'hovered';

function getThorCityName(mapPlace) {
    if (mapPlace.geotype_label === 'city') {
        return mapPlace.name;
    }
    if (mapPlace.city) {
        return mapPlace.city.name;
    }
    return undefined;
}

function pushThorEvent(place) {
    const { mapPlace } = MA.Context;
    const city = getThorCityName(mapPlace);
    thorPushEvent('page_view', {
        ...getThorViewEventProps('price_map', `price_map_${place.geotype_label}`),
        ...(city && { av_city: city, av_zip_code: mapPlace.zip }),
    });
}

function isToggleView() {
    if (typeof toggleView === 'undefined') {
        toggleView = !!window.matchMedia && window.matchMedia('(max-width: 76.875em)').matches;
    }

    return toggleView;
}

function showToggleDetails() {
    $('[data-toggleview]').removeClass(TOGGLE_VIEW_ACTIVE);
    $('[data-toggle-details]').hide();
    $('[data-toggle-map]').show();

    Ga.send({
        eventCategory: GA_CATEGORY,
        eventAction: 'go:prices_page:mobile',
        eventLabel: 'prices:map:infos_button',
    });
}

function hideEstimaPopover() {
    if (isMobile()) {
        return;
    }
    const $popover = $('[data-estima-popover-placeholder]');
    $popover.html('');
}

function loadEstimaPopover(place) {
    if (isMobile() || userDisableEstimaPopover) {
        return;
    }

    HTTPService.getHTML(urlJoin('/prix-immobilier/estima-popover', String(place.id))).then(
        response => {
            const $html = $(response.data);
            const $popover = $('[data-estima-popover-placeholder]');
            $html.find('[data-estima-popover-close]').on('click', e => {
                e.preventDefault();
                userDisableEstimaPopover = true;
                hideEstimaPopover();
            });

            if ($popover.html() === '') {
                $popover.append($html);
            }
            // Update only content to avoid animation
            else {
                $popover
                    .find('[data-estima-popover-content]')
                    .replaceWith($html.find('[data-estima-popover-content]'));
            }
        },
    );
}

/**
 * Helper to load and attach map on page
 * @param {Object} place Reprents the place data
 * @param {Object} placePrices Reprents the prices JSON data
 */
function loadMap(place, placePrices) {
    // Expose instance to global
    MA.mapboxMap = new MapboxMap(place, placePrices);

    mapIsLoaded = true;

    $(window).on(MAEvent.pricesPlaceClicked, () => {
        if (isToggleView()) {
            showToggleDetails();
        }
    });
}

function showToggleMap(place, placePrices) {
    $('[data-toggleview]').addClass(TOGGLE_VIEW_ACTIVE);
    $('[data-toggle-details]').show();
    $('[data-toggle-map]').hide();

    Ga.send({
        eventCategory: GA_CATEGORY,
        eventAction: 'go:map:mobile',
        eventLabel: 'prices:map:carte_button',
    });

    if (!mapIsLoaded) {
        loadMap(place, placePrices);
    } else {
        MA.mapboxMap.map.resize();
    }
}

/**
 * Load realtors with XHR
 * @param {{id: Number, geotype_label: String}} place Place to search realtors in
 * @return {Promise}
 */
function loadRealtors(place) {
    return HTTPService.get(`/prix-immobilier/agences/${place.geotype_label}/${place.id}`);
}

function initializeModal(linkAttribute, popinAttribute) {
    $(linkAttribute).on('click', event => {
        event.preventDefault();
        $.magnificPopup.open({
            fixedContentPos: 'fixed',
            closeBtnInside: false,
            items: {
                type: 'inline',
                src: popinAttribute,
            },
        });
    });
}

function _addressesPaginationClickHandler(event, activeClass) {
    event.preventDefault();
    const $t = $(event.target);
    const $pagination = $('[data-addresses-pagination]');
    const $pageToShow = $(`[data-street-addresses-page=${$t.data('page')}]`);
    const $addressesBlock = $('#addresses');

    // Hode old page
    $('[data-street-addresses-page]').addClass('hide');
    // Display current page
    $pageToShow.removeClass('hide');

    // Handle active item in pagintation
    $pagination.find(`.${activeClass}`).removeClass(activeClass);
    $pagination.find(`[data-page=${$t.data('page')}]`).addClass(activeClass);

    // Trigger image lzy loading
    $pageToShow.find('img:visible').trigger('unveil');

    if ($addressesBlock.prev().offset()) {
        window.scrollTo(0, $addressesBlock.prev().offset().top - 60); // Target the section title, 60px for the magellan fixed navigation
    }
}

/**
 * At street page load
 */
function streetPageReady() {
    const $pages = $('[data-street-addresses-page]');
    const $paginationWrapper = $('[data-street-pagination-wrapper]');
    const pageCount = $pages.length;

    if (pageCount > 1) {
        const $paginationNav = $('<div />', {
            class: 'nav-tabs',
        });
        const $paginationContent = $('<div />', {
            'data-addresses-pagination': '',
            class: 'nav-tabs__content nav-tabs__content--multiline',
        });
        $pages.each(function streetPageEach() {
            const $this = $(this);
            const page = $this.data('street-addresses-page');
            const $items = $this.find('li');

            // Skipping if no address found for this page
            if ($items.length === 0) {
                return;
            }

            // Prepare link object
            const $link = $('<a />', {
                'data-page': page,
                class: page === 0 ? 'nav-tabs__item nav-tabs__item--active' : 'nav-tabs__item',
            });
            // We want to display the first and last address no of the page
            $link.html(`Nº${$items.first().data('name-no')} à ${$items.last().data('name-no')}`);
            $link.on('click', event => {
                _addressesPaginationClickHandler(event, 'nav-tabs__item--active');
            });
            $paginationContent.append($link);
        });
        // Append pagination to dom before the list
        $paginationNav.html($paginationContent);
        $paginationWrapper.html($paginationNav);
    }

    // Estima button click event rather than href link for SEO
    $('[data-address-estima-button]').on('click', function addressEstimaClick() {
        document.location.href = $(this).data('url');
    });
}

function getBorough(place) {
    if (place.borough) {
        return place.borough;
    }

    if (place.boroughs) {
        return place.boroughs[0];
    }

    return undefined;
}

function loadIndices(place) {
    // To avoid IndiceApi overload we load indices at borough level for street and city
    const loadIndiceFromBorough = ['street', 'address', 'subcity'];
    const borough = getBorough(place);
    if (loadIndiceFromBorough.includes(place.geotype_label)) {
        if (borough) return HTTPService.get(`/indices/borough/${borough.id}/price_chart`);
        return HTTPService.get(`/indices/city/${place.city.id}/price_chart`);
    }
    return HTTPService.get(`/indices/${place.geotype_label}/${place.id}/price_chart`);
}

function bindIndiceCharts(place) {
    const chartDefaultOptions = {
        accessibility: {
            enabled: false,
        },
        title: {
            text: undefined,
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: undefined,
            },
            // could have been '7,5' instead of 'Dash', but not authorized by Types. SCSS class will override stroke-dasharray with '7,5', 'Dash' is a fallback
            gridLineDashStyle: 'Dash',
            tickWidth: 0,
        },
        xAxis: {
            type: 'datetime',
            tickWidth: 0,
            maxPadding: 0,
            minPadding: 0,
            endOnTick: false,
            dateTimeLabelFormats: {
                month: '%b %Y',
            },
        },

        chart: {
            height: '33%',
            style: {
                fontFamily:
                    '"WorkSans", -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif',
            },
            spacingBottom: 0,
        },

        tooltip: {
            enabled: false,
        },
        plotOptions: {
            areaspline: {
                color: '#1432be',
                fillColor: 'rgba(20, 50, 190, 0.2)',
                marker: {
                    enabled: false,
                    radius: 2,
                },
                lineWidth: 2,
                threshold: null,
                states: {
                    hover: {
                        enabled: false,
                        lineWidthPlus: 0,
                    },
                },
            },
        },
    };

    loadIndices(place).then(({ data: { datasetApartment, datasetHouse } }) => {
        const chartOptionsApartment = {
            ...chartDefaultOptions,
            series: [
                {
                    id: 'indice_charts',
                    type: 'areaspline',
                    data:
                        datasetApartment.map(value => [
                            new Date(value.date).getTime(),
                            value.value,
                        ]) || [],
                },
            ],
        };
        Highcharts.chart('indice_charts', chartOptionsApartment);

        if (datasetHouse !== null) {
            const chartOptionsHouse = {
                ...chartDefaultOptions,
                series: [
                    {
                        id: 'indice_charts',
                        type: 'areaspline',
                        data:
                            datasetHouse.map(value => [
                                new Date(value.date).getTime(),
                                value.value,
                            ]) || [],
                    },
                ],
            };
            Navigation.handleTabsNav(
                $pricesDetails.find('[evolution-price-tabs-nav]'),
                activeTab => {
                    const $appartmentElements = $('#evolution_apartment');
                    const $houseElements = $('#evolution_house');
                    if (activeTab === '#evolution_apartment') {
                        $appartmentElements.removeClass('hide');
                        $houseElements.addClass('hide');
                        Highcharts.chart('indice_charts', chartOptionsApartment);
                    } else {
                        $appartmentElements.addClass('hide');
                        $houseElements.removeClass('hide');
                        Highcharts.chart('indice_charts', chartOptionsHouse);
                    }
                },
                'nav-tabs-evolution__item--active',
            );
        }
    });
}

function reloadDetails(place) {
    const shouldDisplayIndiceCharts = [
        REGION_GEOTYPE_LABEL,
        SUBREGION_GEOTYPE_LABEL,
        SUBCITY_GEOTYPE_LABEL,
        CITY_GEOTYPE_LABEL,
        ARRMUN_GEOTYPE_LABEL,
        BOROUGH_GEOTYPE_LABEL,
        STREET_GEOTYPE_LABEL,
        ADDRESS_GEOTYPE_LABEL,
    ].includes(place.geotype_label);

    TooltipInit($pricesDetailsContent);

    if (shouldDisplayIndiceCharts) {
        bindIndiceCharts(place);
    }

    InitCommonAccordion();
    initInlineAccordion(
        '.realtor-dropdown',
        '.realtor-dropdown__header',
        '.realtor-dropdown__content',
    );

    $('.list-realtor-wrapper').on('click', e => {
        if (e.target.href && e.target.href !== '#') {
            return;
        }
        if (e.currentTarget.hasAttribute('data-href-id')) {
            const hrefElement = document.getElementById(
                e.currentTarget.getAttribute('data-href-id'),
            );
            window.open(hrefElement.getAttribute('href'), hrefElement.getAttribute('target'));
        }
    });

    // Tracking WA on listings
    $pricesDetailsContent
        .find('[data-tab-listings]')
        .on('toggled', function onTabToggle(event, tab) {
            const selector = tab.children('a').attr('href');
            Wa.setTracking($(selector), MA.Context.waData);
            $(this)
                .parents('section')
                .find('img')
                .trigger('unveil');
        });

    if (MapHelpers.placeIsStreet(place)) {
        streetPageReady();
    }

    Navigation.handleTabsNav(
        $pricesDetails.find('[data-tabs-nav]'),
        undefined,
        'nav-tabs__item--active',
    );
    Navigation.handleTabsNav(
        $pricesDetails.find('[data-prices-popin-tabs]'),
        activeTab => {
            const $appartmentElements = $(
                '.prices-source__apartment-accuracy, .prices-source__apartment-button',
            );
            const $houseElements = $(
                '.prices-source__house-accuracy, .prices-source__house-button',
            );
            if (activeTab === '#prices-popin-appartment') {
                $appartmentElements.removeClass('hide');
                $houseElements.addClass('hide');
            } else {
                $appartmentElements.addClass('hide');
                $houseElements.removeClass('hide');
            }
        },
        'nav-tabs__item--active',
    );

    initializeModal('[data-prices-info-link]', '[data-prices-info-popin]');

    $pricesDetails.find('[data-ua-hit-type]').on('touchstart', function onTouchStartPrice() {
        $(this).addClass(HOVER_ACTIVE);
    });
    $pricesDetails.find('[data-ua-hit-type]').on('touchend', function onTouchEndPrice() {
        $(this).removeClass(HOVER_ACTIVE);
    });

    const loadingClass = 'panel__content--loading';
    const $realtors = $('[data-place-realtors]');
    const $realtorsContainer = $('[data-place-realtors-container]');

    if ($realtors.length > 0) {
        $realtors.addClass(loadingClass);
        $realtors.html(spinnerTemplate({ classes: 'spinner--dots' }));
        loadRealtors(place).then(({ data: { closest_realtor: closestRealtor, realtors } }) => {
            let realtorsItems = 0;

            if (realtors === null) {
                $realtorsContainer.hide();
                $realtors.html('');
            } else {
                $realtors.html(realtors);
                realtorsItems = document.querySelectorAll('[data-realtor-list-item]').length;
            }

            $realtors.removeClass(loadingClass);

            if (closestRealtor) {
                $realtorsContainer.after(closestRealtor);
                realtorsItems += 1;

                Wa.setDisplayTracking($('[data-closest-realtors]'), MA.Context.waData);
            }

            RealtorMap.initializeShowRealtorDetails('realtor-contact');
            initializeRealtorMessagePopin(
                GA_CATEGORY,
                'realtor:message_form',
                'from:prices:realtors_list',
                'prices',
            );

            Ga.set('dimension10', realtorsItems);
            sendCriteoEvent({
                event: 'viewList',
                item: getRealtorIds(realtorItemSelector),
                atype: computeCriteoAType(realtorItemSelector),
            });
            Wa.setDisplayTracking($realtors, MA.Context.waData);
            document.querySelectorAll(realtorItemSelector).forEach((item, index) => {
                const isClosestRealtor = item.parentNode.parentNode.hasAttribute(
                    'data-closest-realtors',
                );
                const avItem = {
                    list_name: isClosestRealtor
                        ? 'price_map_closest_intermediary'
                        : 'price_map_recommended_intermediaries',
                    id: item.getAttribute('data-realtor-id'),
                    index: index.toString(),
                    publication_id: 'MA',
                    name: 'agency',
                    zip_code: item.getAttribute('data-realtor-zip'),
                    country: 'france',
                    city: thorFormatPlaceName(item.getAttribute('data-realtor-city')),
                };

                item.addEventListener('click', () => {
                    thorPushEvent('select_items', {
                        av_items: [avItem],
                    });
                });
            });
        });
    }

    initializeFeaturedRealtors(
        $('[data-place-featured-realtors]'),
        () => loadFeaturedRealtors(place, 'prices'),
        {
            category: GA_CATEGORY,
            labelPrefix: 'prices',
        },
    );

    initializePastSalePopin('data-reference-message', false);
}

function bindRentSellTabEvents() {
    function bindTabEvent(
        elementId,
        { eventCategory = GA_CATEGORY, eventAction, eventLabel } = {},
    ) {
        const tabElement = document.getElementById(elementId);
        if (tabElement) {
            const listener = () => {
                Ga.send({ eventCategory, eventAction, eventLabel });
                tabElement.removeEventListener('click', listener);
            };
            tabElement.addEventListener('click', listener);
        }
    }
    bindTabEvent('price-summary-sell-link', {
        eventAction: 'go:sell_price',
        eventLabel: 'prices:tab:sell',
    });
    bindTabEvent('price-summary-rental-link', {
        eventAction: 'go:rental_price',
        eventLabel: 'prices:tab:rental',
    });
}

function changePlaceDone(response, updateMap, callback, avivFeatureId = null) {
    // Capture AVIV feature ID and isMapClick from pending state or parameter
    const avivId = avivFeatureId || pendingAvivFeatureId;
    const isMapClick = pendingIsMapClick;

    if (response.url !== global.history.state.url) {
        global.history.pushState(
            {
                url: response.url,
                avivFeatureId: avivId, // Store AVIV ID for back navigation
            },
            'place',
            response.url,
        );
        domHelpers.dispatchEvent('pushstate');
    }

    // Clear pending state after use
    pendingAvivFeatureId = null;
    pendingIsMapClick = false;

    // TODO use only one source of truth
    // You should have, I have been trapped
    currentPlace = response.place;
    MA.Context.mapPlace = response.place;
    MA.Context.waData = {
        pageview_id: uuidv4(),
        pageview_category: 'prices',
        place_id: response.place.id,
        place_type: response.place.geotype_label,
    };
    currentPlacePrices = response.market ? response.market.prices : null;

    // Update datalayer
    window.dataLayer.push(response.datalayer);

    $(window).trigger({
        type: MAEvent.pricesPlaceDidChange,
        place: response.place,
        placePrices: response.market ? response.market.prices : null,
        updateMap,
        avivFeatureId: avivId, // Pass AVIV ID to map for layer reload
        isMapClick, // Flag to tell map to reload layers after click navigation
    });

    $pricesDetails.removeClass(LOADING_WRAPPER_ACTIVE);
    $pricesDetailsContent.html(response.html);
    reloadDetails(response.place);

    // Tracking WA on realtor only for display, click is already bound
    Wa.setDisplayTracking($pricesDetails, MA.Context.waData);

    if (MapHelpers.placeIsAddress(response.place)) {
        loadEstimaPopover(response.place);
    } else {
        hideEstimaPopover();
    }

    bindRentSellTabEvents();

    pushThorEvent(currentPlace);

    if (typeof callback === 'function') {
        callback();
    }
}

function changePlaceFail() {
    $pricesDetails.removeClass(LOADING_WRAPPER_ACTIVE);
}

/**
 * function to change place and update the datas
 * @param {string} url
 * @param {Boolean} updateMap
 * @param {function} callback
 * @param {string} avivFeatureId - AVIV feature ID for back navigation
 */
function changePlace(url, updateMap, callback, avivFeatureId = null) {
    $('[data-prices-details]').animate({ scrollTop: 0 }); // scroll back to top
    $(window).trigger({
        type: MAEvent.pricesPlaceWillChange,
    });
    $pricesDetails.addClass(LOADING_WRAPPER_ACTIVE);

    HTTPService.get(`${url}?partial=1`)
        .then(response => {
            changePlaceDone(response.data, updateMap, callback, avivFeatureId);
        })
        .catch(data => {
            if (data.response && data.response.status === 401) {
                // Some browsers does not set responseURL (Guess which ones!)
                // Wait for a better backend response
                if (data.response.request.responseURL) {
                    document.location.href = data.response.request.responseURL;
                } else {
                    changePlaceFail();
                }
                return;
            }
            changePlaceFail();
        });
}

/**
 * Seach a plce for price pages
 * @private
 */
function _initializeGeoSearchBoxes() {
    // Search a place for accessing a market page
    const $geoSearchBoxes = $('[data-geo-searchbox]');
    if ($geoSearchBoxes.length === 0) {
        return;
    }

    $geoSearchBoxes.each(function geoSearchBoxEach() {
        const $geoSearchBox = $(this);
        const $geoSearchField = $(this).find('[data-geo-search-field]');

        $geoSearchField.typeahead(
            {
                hint: true,
                highlight: true,
                minLength: 1,
                autoselect: true,
            },
            typeaheadPlaceFieldDatasets($geoSearchField.data('place-types')),
        );

        $geoSearchField.on('typeahead:selected', (event, place) => {
            Ga.send({
                hitType: 'event',
                eventCategory: $geoSearchField.data('ua-event-category'),
                eventAction: `go:prices:${place.geotype_label}`,
                eventLabel: $geoSearchField.data('ua-event-label'),
            });

            Common.getSearchFormUrl(place).then(url => {
                changePlace(urlJoin($geoSearchBox.data('base-url'), url, '/'), true, () => {
                    $geoSearchBoxes.each(function geoSearchBoxUrlEach() {
                        $(this)
                            .find('[data-geo-search-field]')
                            .trigger('blur')
                            .typeahead('val', '');
                    });
                });
            });
        });

        // prevent form submission when using return to select a place
        $geoSearchField.keypress(e => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
    });
}

function mapToPlace(place, lngLat) {
    const fields = ['city_slug', 'street_slug', 'street_id', 'slug', 'name'];

    switch (place.geotype_label) {
        case 'country':
            changePlace(HTTPService.getPlaceURL(), false);
            break;
        case 'region':
        case 'subregion':
        case 'city':
        case 'arrmun':
            changePlace(HTTPService.getPlaceURL(place), false);
            break;
        case 'parcelle':
            $.getJSON(
                `${urlJoin(
                    MA.Config.GEOAPI_URL,
                    'parcelles',
                    String(place.id),
                    'addresses',
                )}?fields=${fields.join()}`,
            ).done(response => {
                if (response.response.children.length > 1) {
                    for (let i = 0; i < response.response.children.length; i++) {
                        const params = {};
                        $.each(fields, (index, field) => {
                            let urlField = field;
                            if (field === 'slug') {
                                urlField = 'address_slug';
                            } else if (field === 'name') {
                                return;
                            }
                            params[urlField] = response.response.children[i][field];
                        });
                        response.response.children[i].url = HTTPService.getPlaceURL(params);
                    }
                    MA.mapboxMap.showListAddressInfoWindow(response.response, lngLat);
                } else if (response.response.children.length === 1) {
                    const params = {};
                    $.each(fields, (index, field) => {
                        let urlField = field;
                        if (field === 'slug') {
                            urlField = 'address_slug';
                        } else if (field === 'name') {
                            return;
                        }
                        params[urlField] = response.response.children[0][field];
                    });
                    $.event.trigger({
                        type: 'gaSendFitBounds',
                        placeType: 'address',
                    });
                    if (params.address_slug === null) {
                        params.address_slug = '';
                    }
                    changePlace(HTTPService.getPlaceURL(params), false);
                }
            });
            break;
        default:
            break;
    }
}

function bindNavigationEvents() {
    $(window).on(MAEvent.mapPricesNavigationChanged, (e, data) => {
        if (data && data.url) {
            // On back/forward navigation, pass the stored AVIV feature ID
            changePlace(data.url, true, null, data.avivFeatureId);
        }
    });

    $(window).on(MAEvent.mapPlaceClicked, event => {
        // Store AVIV feature ID for history state (will be captured in changePlaceDone)
        pendingAvivFeatureId = event.place?.avivFeatureId || null;
        // Store isMapClick flag to tell map to reload layers after navigation
        pendingIsMapClick = event.place?.isMapClick || false;
        mapToPlace(event.place, event.lngLat, event.zoom);
    });

    $(window).on(MAEvent.pricesPlaceWillChange, () => {
        $pricesDetails.addClass(LOADING_WRAPPER_ACTIVE);
    });

    $(window).on(MAEvent.pricesPlaceDidChange, () => {
        $pricesDetails.removeClass(LOADING_WRAPPER_ACTIVE);
    });

    $(window).on(MAEvent.mapReady, event => {
        if (!MapHelpers.placeIsAddress(event.place)) {
            return;
        }
        loadEstimaPopover(event.place);
    });
}

export function domReady(place, placePrices) {
    pushThorEvent(place);
    bindNavigationEvents();
    bindRentSellTabEvents();
    global.history.replaceState(
        { url: $('.breadcrumbs li:last-child a').attr('href') },
        'indexplace',
    );

    currentPlace = place;
    currentPlacePrices = placePrices || null;

    $pricesDetailsContent.on('click', '[data-linked-place]', function priceDetailClick(e) {
        e.preventDefault();

        let url = $(this).data('url') || atob($(this).data('obfuscate'));
        if ($(this).data('medium')) {
            url = url.concat(`?m=${$(this).data('medium')} `);
        }
        if (e.ctrlKey || e.metaKey) {
            window.open(url, '_blank');
        } else {
            changePlace(url, true);
        }
    });

    $mapContainer.on('click', '[data-linked-place]', function mapContainerClick(e) {
        e.preventDefault();
        const url = $(this).data('url');
        if (isMobile()) {
            $('[data-toggle-details]').removeClass('hide');
            $('[data-toggle-map]').addClass('hide');
            $('[data-prices-details]').addClass('active');
            $('[data-prices-map]').removeClass('active');
        }
        MA.mapboxMap.hideListAddressInfoWindow();
        changePlace(url, !this.hasAttribute('data-linked-address'));
    });

    if (!hasTouchEvents()) {
        $('[data-control-tooltip]').qtip({
            position: {
                my: 'center right',
                at: 'center left',
                corner: {
                    target: 'leftMiddle',
                    tooltip: 'rightMiddle',
                },
            },
            style: {
                classes: 'qtip-tipsy',
            },
        });
    }

    if (isToggleView()) {
        $('[data-toggle-map]').on('click', () => {
            showToggleMap(currentPlace, currentPlacePrices);
        });
        $('[data-toggle-details]').on('click', showToggleDetails);
    }

    // Loading map
    if (!isToggleView()) {
        loadMap(place, placePrices);
    }

    _initializeGeoSearchBoxes();

    reloadDetails(place);

    /* eslint-disable camelcase */
    const { references, address_references } = MA.Context;
    if (references || address_references) {
        let combined_References;

        if (references && address_references) {
            combined_References = [...address_references, ...references];
        } else if (references && !address_references) {
            combined_References = references;
        } else {
            combined_References = address_references;
        }

        document.querySelectorAll('[data-reference-item]')?.forEach((item, index) => {
            const { city, id, item_type, zip } = combined_References[index];
            const isAddressLevel = MA.Context.mapPlace.geotype_label === 'address';
            const avItem = {
                list_name: isAddressLevel
                    ? 'price_map_transactions_at_this_address'
                    : 'price_map_recent_sold_properties',
                id: id.toString(),
                index: index.toString(),
                estate_type: EstateType[item_type.key],
                distribution_type: '2',
                publication_id: 'MA',
                name: 'sold_property',
                zip_code: zip,
                country: 'france',
                city: thorFormatPlaceName(city.name),
            };

            item.addEventListener('click', () => {
                thorPushEvent('select_items', {
                    av_estate_type_global: EstateType[item_type.key],
                    av_distribution_type_global: '2',
                    av_items: [avItem],
                });
            });
        });
    }
    /* eslint-enable camelcase */
    document.querySelectorAll('[data-outlink]')?.forEach(outlink =>
        outlink.addEventListener('click', () => {
            thorPushEvent('outlink', {
                link_url: outlink.href,
                outbound: true,
                av_zone: 'middle',
            });
        }),
    );
}
